import { ITeacher, ILvl4Item, IProjectActions, IProjectKind } from 'interfaces'
export interface IEvaluationTool {
  name: string
  id: string
}
export interface IProjectGrade {
  readonly id: string
  readonly name: string
}
export interface IProjectNew {
  readonly id: string
  readonly name: string
  readonly stages: string
  readonly kind: IProjectKind
  readonly finalProductKind: string
  readonly modality: string
  readonly purpose: string
  readonly objectives: string
  readonly finalProductDescription: string
  readonly coverImage: string
  readonly synopsis: string
  readonly shareCommunity: boolean
  /** Only present on responses that include the form payload (e.g. /api/projects/:id/edit).
   *  The plain GET /api/projects/:id show endpoint does not currently expose grades. */
  readonly grades?: ReadonlyArray<IProjectGrade>
  readonly updatedAt: string
  readonly status: string
  readonly schoolTermId?: string
  readonly groupName: string
  readonly totalMeetings: number
  readonly startFinalAssessment: boolean
  readonly finalAssessmentPath: string
  readonly muralPath: string
  readonly tutorMain: ITeacher
  readonly evaluationTools: IEvaluationTool[]
  readonly projectItems: {
    readonly contents: ILvl4Item[]
    readonly specificSkills: ILvl4Item[]
  }
  readonly actions: IProjectActions
  readonly userPrompt?: string
  readonly areas?: Array<{ id: string; name: string }>
}
